export function sanitizer(html) {
  const allowedTags = ["b", "span", "strong"];

  const tagPattern = new RegExp(
    `<(/?)(?!(${allowedTags.join("|")}))\\w+\\s*[^>]*>`,
    "gi"
  );

  return html.replace(tagPattern, "");
}



// WEBPACK FOOTER //
// ./src/plugins/sanitizer.js